const ctaVideoOrImage: NodeListOf<HTMLIFrameElement> =
  document.querySelectorAll('[id^="cta-video-or-image-"]');

// Toggle video dialog, based on videos in the cta-video-or-image component
ctaVideoOrImage.forEach((iframe) => {
  document.addEventListener("dialog.onopen", () => {
    if (iframe.dataset.src) {
      iframe.setAttribute("src", iframe.dataset?.src + "?enablejsapi=1");
      iframe.removeAttribute("data-src");
    }
  });

  document.addEventListener("dialog.onclose", () => {
    iframe.contentWindow?.postMessage(
      '{"event":"command","func":"pauseVideo","args":""}',
      "*",
    );
  });
});
